import React, { Fragment, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Mcs from "./EventCheck/Mcs";
import ResultTable from "./EventCheck/ResultTable";
import Meta from "../lib/Meta";
import { makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { url } from "../lib/Common";
import axios from "axios";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles({
  CircularDiv: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    marginBottom: 20,
  },
  divVisible: {
    visibility: "visible",
  },
  divUnVisible: {
    visibility: "hidden",
  },
  divDisPlay: {
    display: "flex",
  },
  divUnDisPlay: {
    display: "none",
  },
  divLoadingFont: {
    fontWeight: "bold",
    fontSize: "1.25rem",
  },
  "@media screen and (min-width:600px)": {
    CircularDiv: {
      marginBottom: 30,
    },
  },
});

function EventCheck({ partcode }) {
  const classes = useStyles();
  const history = useHistory();
  useEffect(() => {
    const urlPartCodeCheck = url + "/api/specialMember/partCodeCheck";
    axios
      .post(
        urlPartCodeCheck,
        {
          partCode: partcode,
        },
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.COUNT !== "1") history.push("/404");
      })
      .catch((_) => {
        history.push("/404");
      });
  }, [partcode, history]);

  const [loading, setLoading] = useState(false);
  const mcsRef = useRef(null);
  const [styleInfo, setStyleInfo] = useState(null);
  const [partStock, setPartStock] = useState(null);
  const [partStockInfo, setPartStockInfo] = useState(null);

  const metaData = {
    image: "%PUBLIC_URL%/logo192.png",
    title: "특판 재고 및 가격 조회",
    description: "특판 재고 및 가격 조회 페이지입니다.",
    width: 192,
    height: 192,
    canonical: `event/${partcode}`,
  };
  useEffect(() => {
    mcsRef.current.value = "";
  }, [loading]);
  return (
    <Fragment>
      <div
        className={classNames(
          classes.CircularDiv,
          loading ? classes.divDisPlay : classes.divUnDisPlay
        )}
      >
        <CircularProgress color="secondary" />
      </div>
      <div
        className={classNames(
          loading ? classes.divDisPlay : classes.divUnDisPlay,
          classes.CircularDiv,
          classes.divLoadingFont
        )}
      >
        로딩중입니다...
      </div>
      <div className={loading ? classes.divUnVisible : classes.divVisible}>
        <Meta data={metaData} />
        <Mcs
          partcode={partcode}
          mcsRef={mcsRef}
          setStyleInfo={setStyleInfo}
          setPartStock={setPartStock}
          setPartStockInfo={setPartStockInfo}
          setLoading={setLoading}
        ></Mcs>
        <hr />

        <ResultTable
          styleInfo={styleInfo}
          partStock={partStock}
          partStockInfo={partStockInfo}
        ></ResultTable>
      </div>
    </Fragment>
  );
}
EventCheck.propTypes = {
  partcode: PropTypes.string.isRequired,
};
export default EventCheck;
